import { Page } from './page.model';

export class PagedData<T> {
    data: T[] = new Array<T>();
    page: Page = new Page();
}
